
const routes = [
  {
    path: '/expr',
    redirect: { name: 'ExprList' },
    meta: { layout: 'default' },
    children: [
      // 견학·체험 목록
      {
        path: 'list/:instId?',
        name: 'ExprList',
        meta: { layout: 'default', menu: 'expr' },
        component: () => import('@/pages/expr/ExprListView.vue')
      },
      // 견학·체험 상세
      {
        path: 'detail/:instId/:ftrPrgrmId',
        name: 'ExprDetail',
        meta: { layout: 'default', menu: 'expr' },
        component: () => import('@/pages/expr/ExprDetailView.vue'),
        props: true
      },
      // 견학·체험 예약
      {
        path: 'rsvt/:instId/:ftrPrgrmId',
        name: 'ExprRsvt',
        meta: { layout: 'default', menu: 'expr' },
        component: () => import('@/pages/expr/ExprRsvtView.vue'),
        props: true
      },
      // 견학·체험 완료
      {
        path: 'done',
        name: 'ExprDone',
        meta: { layout: 'default', menu: 'expr' },
        component: () => import('@/pages/expr/ExprDoneView.vue')
      },
    ]
  }
]

export default routes


